import { render, staticRenderFns } from "./ReactMountDashboardGerencial.vue?vue&type=template&id=3bcba7d9"
import script from "./ReactMountDashboardGerencial.vue?vue&type=script&lang=ts"
export * from "./ReactMountDashboardGerencial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bcba7d9')) {
      api.createRecord('3bcba7d9', component.options)
    } else {
      api.reload('3bcba7d9', component.options)
    }
    module.hot.accept("./ReactMountDashboardGerencial.vue?vue&type=template&id=3bcba7d9", function () {
      api.rerender('3bcba7d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/ReactMountDashboardGerencial.vue"
export default component.exports